import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { tap, switchMap, catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { StorageService } from '../storage/storage.service';
import { CommonService } from '../common/common.service';

const TOKEN_STORE = 'token';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  userValueStore: any; //This object is not guaranteed to hold current user; Be careful;
  private userSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public user$: Observable<any> = this.userSubject.asObservable().pipe(
    switchMap((token) => this.getAuthenticatedUser$),
    tap((_) => (this.userValueStore = _)),
  );

  private loggedIn = new BehaviorSubject<boolean>(false);

  selected_role: any = "";


  constructor(
    private router: Router,
    private http: HttpClient,
    private storageService: StorageService,
    private commonService: CommonService,
    private route: ActivatedRoute,
  ) {
    this.userSubject.next(this.storageService.get(TOKEN_STORE));

  }

  public get isLoggedIn() {
    return this.loggedIn.asObservable();
  }

  getUserLoggedIn(): Observable<boolean> {
    return this.loggedIn.asObservable();
  }

  getLoginStatus() {
    let token = localStorage.getItem('token');
    if (token && token !== 'null') {
      this.loggedIn.next(true);
    } else {
      this.loggedIn.next(false);
    }
  }

  // public get getAuthenticatedUser$(): Observable<any> {
  //   let userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  //   return this.http
  //     .post<any>(
  //       `${environment.apiEndpoint}/authenticatedUser/?timezone=` +
  //         userTimezone,
  //       {},
  //     )
  //     .pipe(
  //       map((user) => {
  //         this.storageService.set("user_details", user);
  //         return user;
  //       }),
  //     );
  // }

  public get getAuthenticatedUser$(): Observable<any> {
    let userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return this.http
      .post<any>(
        `${environment.apiEndpoint}/authenticatedUser/?timezone=` +
          userTimezone,
        {role: this.selected_role},
      )
      .pipe(
        map((user) => {
          this.storageService.set("user_details", user);
          return user;
        }),
        catchError((error) => {
          // Handle the error here (e.g., log it, show a notification, etc.)
          // console.error('Error occurred while fetching authenticated user:', error);
          // Optionally return a default value or throw the error again to propagate it

          this.logout();
          this.router.navigate(['/login']);
          return throwError(() => {
            // new Error('Failed to fetch authenticated user')
          });
        })
      );
  }

  public get userIsAuthenticated$(): Observable<boolean> {
    return this.getAuthenticatedUser$.pipe(map((user) => !!user));
  }

  public get userValue(): any {
    return this.userSubject.value;
  }

  public set token(token: string) {
    this.storageService.set(TOKEN_STORE, token);
    this.userSubject.next(<any>token);
  }

  public refreshAuthUser() {
    this.userSubject.next(this.storageService.get(TOKEN_STORE));
  }

  return_url: any;
  setReturnUrl(url: string): void {
    this.return_url = url;
  }

  loginWithEmailPassword(obj: {
    email: string;
    password: string;
    role: any;
    otp: any;
  }): Observable<any> {
    if (obj.email === undefined) {
      throw new Error('Missing parameter: Email');
    }
    if (obj.password === undefined) {
      throw new Error('Missing parameter: Password');
    }

    this.selected_role = obj.role;

    return this.http
      .post<{ token: string }>(`${environment.apiEndpoint}/auth/token/`, obj)
      .pipe(
        tap((result) => {
          // this.storageService.removeAll();
          this.token = result.token;
          // this.storageService.set("token", this.token);
        }),
        switchMap((_) => this.getAuthenticatedUser$),
        tap((user) => {
          this.storageService.set('user_details', user);
          if (this.return_url) {
            this.router.navigateByUrl(this.return_url);
          } else {
            if (user.role.role == 1) {
              this.router.navigate(['/admin/dashboard']);
            } else if (user.role.role == 2) {
              this.router.navigate(['/admin/dashboard']);
            } else if (user.role.role == 3) {
              // this.router.navigate(['/executive/my-portfolio']);
              this.router.navigate(['/executive/dashboard']);
            } else if (user.role.role == 4) {
              this.router.navigate(['/advisor-manager']);
            } else if (user.role.role == 5) {
              this.router.navigate(['/advisor']);
            } else if (user.role.role == 6) {
              this.router.navigate(['/afa']);
            } else if (user.role.role == 7) {
              this.router.navigate(['/assistant']);
            } else if (user.role.role == 8) {
              this.router.navigate(['/relationship-manager']);
            } else if (user.role.role == 10) {
              // this.router.navigate(['/leadership/my-portfolio']);
              this.router.navigate(['/leadership/dashboard']);
              // this.router.navigate(['/leadership/advisor-recruiting-workflow']);

            } else if (user.role.role == 11) {
              // this.router.navigate(['/marketing-team']);
			        this.router.navigate(['/opportunity']);
            } else if (user.role.role == 13) {
			        this.router.navigate(['/lending-officer']);
            } else if (user.role.role == 14) {
              this.router.navigate(['/insurance-agent']);
            }
          }

          this.loggedIn.next(true);
        }),
        catchError((err) => {
          return throwError(err);
        }),
      );
  }

  // logout() {
  //   this.storageService.removeAll();
  //   this.token = null;
  //   this.router.navigate(['/login']);
  //   this.loggedIn.next(false);
  // }

  logout() {
    let token = localStorage.getItem('token');
    if (token && token !== 'null') {
      this.commonService.getData('/log_out/').subscribe(
        (res: any) => {
          this.storageService.removeAll();
          this.token = null;
          this.router.navigate(['/login']);
          this.loggedIn.next(false);
        },
        (err) => {
          this.commonService.showToast('error', err.error);
        },
      );
    } else {
      this.storageService.removeAll();
      this.token = null;
      this.loggedIn.next(false);
    }


  }

}
